import { DatePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EnumeratedTypesRepositoryService, FiltersComponent, Order, OrderRepositoryService, SelectOption } from 'reg-hub-common';
import { EnvironmentUrlService } from '../../services/environment-url/environment-url.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { forkJoin, Subject, take, takeUntil } from 'rxjs';

@Component({
    selector: 'app-bundle-orders-filter',
    templateUrl: './bundle-orders-filter.component.html',
    styleUrl: './bundle-orders-filter.component.css',
    providers: [DatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BundleOrdersFilterComponent extends FiltersComponent<Order> implements OnInit {
  protected bundleID: string = "";
  protected _orderTypeOptions: SelectOption[] = [];
  protected _orderStatusTypeOptions: SelectOption[] = [];

  protected autoExpand: boolean = false;
  protected autoRedirect: boolean = false;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private enumerationRepo: EnumeratedTypesRepositoryService,
    private environment: EnvironmentUrlService,
    private route: ActivatedRoute,
    private router: Router,
    ordersRepo: OrderRepositoryService,
    formBuilder: FormBuilder,
    datePipe: DatePipe) {
    super(
      ordersRepo,
      formBuilder,
      datePipe);
  }

  ngOnInit() {
    this.repo.resource$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(orders => {
        const ordersArray = orders as Order[];
        if (orders != null && this.autoRedirect == true && ordersArray.length == 1) {
          this.router.navigate(['orders', orders[0].id]);
        }
      });

    this.activatedRoute.paramMap.subscribe(params => {
      this.bundleID = params.get('bundleID')!;
    });

    let requests = [
      this.enumerationRepo.getOrderTypesAsSelectOptions(this.environment.urlAddress),
      this.enumerationRepo.getOrderStatusTypesAsSelectOptions(this.environment.urlAddress),
    ];

    forkJoin(requests).subscribe(values => {
      this._orderTypeOptions = values[0];
      this._orderStatusTypeOptions = values[1];
    });

    this._filterForm = this.formBuilder.group({
      referenceNumber: [null],
      orderTypes: [[]],
      status: [[]],
      userID: [null],
      userGroupID: [null],
      dateRequestedFrom: [null],
      dateRequestedTo: [null],
      orderStatusUpdatedDateFrom: [null],
      orderStatusUpdatedDateTo: [null],
      isVisible: [true],
      registrationOrFileNumber: [null],
      registrationDateFrom: [null],
      registrationDateTo: [null],
      firstName: [null],
      lastName: [null],
      dateOfBirth: [null],
      businessName: [null],
      serialNumber: [null],
      sortColumn: ['orderStatusUpdatedDate'],
      sortDirection: ['desc'],
      QCFormTypeIDs: [null],
      isChildSearch: [false],
      bundleID: [this.bundleID]
    });

    this._defaultParams = this.buildParamsFromForm(this._filterForm);

    this.route.queryParams.pipe(take(1)).subscribe(routeQueryStringParams => {
      const routeQueryStringParamKeys = Object.keys(routeQueryStringParams);

      if (routeQueryStringParamKeys.length > 0) {
        this.autoRedirect = routeQueryStringParams["autoRedirect"] == 'true';
        let preFilteredParams = this.buildParamsFromObject(routeQueryStringParams);

        routeQueryStringParamKeys.forEach(key => {
          const control = this._filterForm.get(key);

          if (control) {
            control.setValue(routeQueryStringParams[key]);
            this._filterForm.markAsDirty();
            this.autoExpand = routeQueryStringParams["autoExpand"] ?? false;
            this.filtered = true;
          }
        });

        this.repo.getFirstPage(preFilteredParams);
      } else {
        this.repo.getFirstPage(this._defaultParams);
      }
    });
  }

  ngOnDestroy(): void {
    // Signal all subscriptions to complete
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  protected handleJurisdictionFormReady(event: FormGroup) {
    this._filterForm.setControl('country', event);
  }
}
